var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { useWorkplaceServiceRequestContext } from '../context/WorkplaceServiceRequestContext';
export var useWorkplaceServiceRequestIframe = function () {
    var _a = useWorkplaceServiceRequestContext(), onSubmitIframe = _a.onSubmitIframe, onSuccessfulRequest = _a.onSuccessfulRequest, handleWorkplaceServiceError = _a.handleWorkplaceServiceError, editingEvent = _a.editingEvent;
    var _b = __read(useState(false), 2), loadingRequestService = _b[0], setLoadingRequestService = _b[1];
    // Used for accessing the child iframes api
    var _c = __read(useState(), 2), child = _c[0], setChild = _c[1];
    var handleError = function () {
        handleWorkplaceServiceError();
    };
    var handleSubmit = function (serviceRequestFormStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var data, _a, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!child) return [3 /*break*/, 8];
                    if (!serviceRequestFormStatus) {
                        return [2 /*return*/];
                    }
                    setLoadingRequestService(true);
                    if (!(serviceRequestFormStatus.type === 'create')) return [3 /*break*/, 5];
                    if (!editingEvent) return [3 /*break*/, 2];
                    return [4 /*yield*/, child.requestMeetingServiceForExistingEventAtSpace()];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, child.requestMeetingServiceForDraftEventAtSpace()];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    data = _a;
                    if (data.type === 'error') {
                        /* @TODO this is broken for invalid form errors
                          we shouldn't handle this if the error is just an invalid form right?
                        */
                        handleWorkplaceServiceError({ error: data.translatedReason });
                    }
                    if (data.type === 'success') {
                        onSuccessfulRequest();
                        onSubmitIframe();
                    }
                    _b.label = 5;
                case 5:
                    if (!(serviceRequestFormStatus.type === 'edit')) return [3 /*break*/, 7];
                    return [4 /*yield*/, child.changeAnswersOnMeetingServiceRequest()];
                case 6:
                    data = _b.sent();
                    if (data.type === 'error') {
                        if (data.reason === 'conflict') {
                            // Utilizes the global WorkplaceServiceRequestContext.onError which
                            // will close the sidebar and refetch the space for the meeting service
                            handleWorkplaceServiceError({
                                shouldRefetch: true,
                                error: data.translatedReason,
                            });
                        }
                        else {
                            // For any other error, keep the sidebar open and show the error toast
                            /* @TODO Add back toast error */
                            // toast.error(
                            //   data.translatedReason,
                            //   'workplace-service-request-drawer'
                            // );
                        }
                    }
                    if (data.type === 'success') {
                        onSuccessfulRequest();
                        onSubmitIframe();
                        /* @TODO Add back toast success */
                        // toast.success(
                        //   t('service_request_details.edit_service_request.success')
                        // );
                    }
                    _b.label = 7;
                case 7:
                    setLoadingRequestService(false);
                    _b.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return {
        handleSubmit: handleSubmit,
        handleError: handleError,
        setChild: setChild,
        child: child,
        loadingRequestService: loadingRequestService,
    };
};
